import React from 'react';
import { Plus, Settings, Palette, Zap } from 'lucide-react';

const Sidebar = ({ onAddQuestion, onNavigate, activeSection }) => {
  const navItems = [
    { id: 'settings', label: 'Form Settings', icon: Settings },
  ];

  return (
    <aside className="w-64 bg-white border-r border-gray-200 overflow-y-auto hidden lg:block">
      <div className="p-4">
        <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
          Build
        </h3>
        
        <button
          onClick={onAddQuestion}
          className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue/90 transition-colors flex items-center justify-center gap-2 font-medium mb-6"
          data-tour="add-question"
        >
          <Plus size={20} />
          <span>Add Question</span>
        </button>

        <div className="space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeSection === item.id;
            
            return (
              <button
                key={item.id}
                onClick={() => onNavigate(item.id)}
                className={`w-full px-3 py-2 text-left rounded-lg transition-colors text-sm flex items-center gap-3 ${
                  isActive 
                    ? 'bg-blue/10 text-blue font-medium' 
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <Icon size={18} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;